import { makeStyles } from '@material-ui/core';
import {
  Card,
  Color,
  Expandable,
  ExpandableHeader,
  Flex,
  Icon,
  IconEnum,
  Text,
} from 'component-library';
import { FourPartTestItems } from 'pages/tax-processing/expense-classification/components/rd-expenses/four-part-test/FourPartTestItems';
import React, { useEffect, useState } from 'react';

const useStyles = makeStyles(() => ({
  carousel: {
    borderRadius: '4px',
    borderLeft: `3px solid ${Color.blue._60}`,
    width: '100%',
  },
  carouselCard: {
    backgroundColor: `${Color.neutral._light_20} !important`,
    height: '100%',
    padding: '32px',
  },
  cardContent: {
    backgroundColor: `${Color.neutral.white}`,
    border: `solid 1px ${Color.neutral._20}`,
    padding: '32px',
  },
  cardMainTitle: {
    fontWeight: 700,
    marginTop: -7,
  },
  cardSubtitle: {
    fontWeight: 500,
    marginTop: -5,
  },
  introDescription: {
    fontSize: 15,
  },
  introDescription2: {
    paddingBottom: '24px',
  },
  header: {
    fontWeight: 700,
  },
  listItems: {
    marginLeft: 25,
    paddingLeft: 0,
    fontSize: '15px',
    '& li': {
      padding: '5px 0px',
    },
  },
  iconContainer: {
    background: Color.neutral._light_20,
    padding: '4px',
    borderRadius: '16px',
    height: '32px',
  },
  researchIcon: {
    paddingLeft: '5px',
  },
  cardHeader: {
    boxShadow:
      '0px 0px 4px rgba(21, 36, 31, 0.04),0px 0px 16px rgba(238, 238, 238, 0.16)',
    border: `1px solid ${Color.neutral._20}`,
    margin: '32px 0',
  },
  showLess: {
    color: Color.blue._60,
    width: '130px',
    fontWeight: 500,
  },
  showLessButton: {
    display: 'flex',
    gap: '8px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  icon: {
    height: '95px',
  },
}));

export const FourPartTest = () => {
  const classes = useStyles();

  const [showEducationalCard, setshowEducationalCard] = useState(true);
  const [educationalCardEditMode, seteducationalCardEditMode] = useState(true);

  useEffect(() => {
    if (educationalCardEditMode) {
      setshowEducationalCard(true);
    } else {
      setshowEducationalCard(false);
    }
  }, [educationalCardEditMode]);

  return (
    <>
      {!showEducationalCard && !educationalCardEditMode && (
        <ExpandableHeader
          editMode={educationalCardEditMode}
          setEditMode={seteducationalCardEditMode}
          title={`Four-part test to qualify for R&D credit`}
          subtitle={`Your company would qualify for the R&D tax credit if you had at least one project last year that passes this four-part test.`}
          labelText={'Show More'}
          dataTestId={`educational-card-header`}
          className={classes.cardHeader}
        />
      )}
      <Expandable expand={showEducationalCard}>
        <Card className={classes.carouselCard}>
          <Flex direction='row' gap={16} justifyContent='space-between'>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img
                style={{
                  width: '100px',
                  height: '100px',
                  marginTop: '-8px',
                }}
                src={`${process.env.PUBLIC_URL}/images/graphics/document-with-magnify-glass.svg`}
                alt={'document with magnify glass'}
              />
            </div>
            <Flex direction='column' gap={8}>
              <Text className={classes.header} variant='medium' size={23}>
                Four-part test to qualify for R&D credit
              </Text>
              <Text
                className={classes.introDescription}
                size={15}
                paddingBottom={24}
              >
                Your company would qualify for the R&D tax credit if you had at
                least one project last year that passes this four-part test.
              </Text>
            </Flex>
            <Flex direction='row' gap={8} className={classes.showLess}>
              <span
                className={classes.showLessButton}
                onClick={() => {
                  seteducationalCardEditMode(false);
                }}
              >
                Show less{' '}
                <Icon
                  size={20}
                  name={IconEnum.chevron_up}
                  color={Color.blue._60}
                />
              </span>
            </Flex>
          </Flex>
          <Flex direction='column' gap={8} className={classes.cardContent}>
            <FourPartTestItems />
          </Flex>
        </Card>
      </Expandable>
    </>
  );
};
